<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading">
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">{{$t('基本信息')}}</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">{{$t('订单号')}}：</span>
              {{ detail.order_no }}
            </div>
          </el-col>
          <el-col :span="5" v-if="detail.user">
            <div class="pb16">
              <span class="gray9">{{$t('买家')}}：</span>
              {{ detail.user.nickName }}
              <span>{{$t('用户')}}ID：({{ detail.user.user_id }})</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">{{$t('订单金额')}} (€)：</span>
              {{ detail.total_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">{{$t('实付款金额')}} (€)：</span>
              {{ detail.pay_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">{{$t('支付方式')}}：</span>
              {{ detail.pay_type.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">{{$t('交易状态')}}：</span>
              {{ detail.order_status.text }}
            </div>
          </el-col>
        </el-row>
      </div>
      <!--商户信息-->
      <div v-if="detail.supplier">
        <div class="common-form mt16">{{$t('门店信息')}}</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('使用门店名称')}}：</span>
                {{ detail.supplier.name }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('门店联系人')}}：</span>
                {{ detail.supplier.link_name }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('门店电话')}}：</span>
                {{ detail.supplier.link_phone }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--菜品信息-->
      <div class="common-form mt16">{{$t('团购信息')}}</div>
      <div class="table-wrap">
        <el-table size="small" :data="detail.product" border style="width: 100%">
          <el-table-column prop="product_name" :label="$t('名称')" width="400">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image.file_path" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.group_name }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="total_num" :label="$t('购买数量')">
            <template slot-scope="scope">
              <p>x {{ scope.row.total_num }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="total_price" :label="`${$t('菜品总价')}(€)`">
            <template slot-scope="scope">
              <p>￥ {{ scope.row.total_price }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--付款信息-->
      <div class="table-wrap" v-if="detail.pay_status.value == 20">
        <div class="common-form mt16">{{$t('付款信息')}}</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('应付款金额')}}：</span>
                {{ detail.pay_price }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('支付方式')}}：</span>
                {{ detail.pay_type.text }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('支付流水号')}}：</span>
                {{ detail.transaction_id }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('付款状态')}}：</span>
                {{ detail.pay_status.text }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('付款时间')}}：</span>
                {{ detail.pay_time }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--商户信息-->
      <div v-if="detail.code_no">
        <div class="common-form mt16">{{$t('券码信息')}}</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('核销券码')}}：</span>
                {{ detail.code_no }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('有效期')}}：</span>
                {{ detail.end_time }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">{{$t('状态')}}：</span>
                {{ detail.state_text }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">{{$t('返回上一页')}}</el-button>
    </div>
  </div>
</template>

<script>
  import GroupApi from '@/api/group.js';
  import {
    deepClone,

  } from '@/utils/base.js';
  export default {
    components: {},
    data() {
      return {
        active: 0,
        /*是否加载完成*/
        loading: true,
        /*订单数据*/
        detail: {
          order_no: '',
          pay_status: [],
          pay_type: [],
          user: {},
          product: [],
          order_status: [],
          supplier: {
            name: ''
          },
          code_no: '',
          state_text: ''
        },
      };
    },
    created() {
      /*获取列表*/
      this.getParams();
    },
    methods: {
      next() {
        if (this.active++ > 4) this.active = 0;
      },
      /*获取参数*/
      getParams() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.$route.query.order_id;
        GroupApi.orderDetail({
              order_id: params
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.detail = data.data.detail;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/marketingtool/group/order/detail.vue